module.exports = __webpack_public_path__ + "static/media/codeQuiz.76ffd441.gif";